import React, {useState, useEffect} from 'react';
import { APIloader } from '../Commons';

const dataContext = React.createContext(null);

export const DataProvider = ({children, request, params}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const result = await APIloader(request, params);
        if(!result || result.errors)
          setData(false); // TODO: implement error handling
        else
          setData(result);
      } catch (err) {
        //setError(err);
        // do nothing for now
      }
    };

    setData(false); // reset data
    loadData();
  }, [request]);

  return (
    <dataContext.Provider value={data}>
      {children}
    </dataContext.Provider>
  );
}

export const useData = () => {
  const data = React.useContext(dataContext);
  return data || false;
}